import Repository from '../axios'
import {
  defaultPagination
} from "@/constants/config";
const resource = "/admin/system_setting";

export default {
  getRegion(id) {
    return Repository.get(`${resource}/regions/${id}`)
  },
  getListOfRegions(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/regions?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  fetchRegionsWithoutPagination() {
    return Repository.get(`${resource}/regions?is_paginate=0`)
  },
  updateRegion(id, payload) {
    return Repository.put(`${resource}/regions/${id}`, payload)
  },
  createRegion(payload) {
    return Repository.post(`${resource}/regions`, payload)
  },
  deleteRegion(id) {
    return Repository.delete(`${resource}/regions/${id}`)
  },
};
